/* eslint-disable no-new-object */
import {
    MARKETINGPLAYCONFIGURATION
} from "redux/constants/action-types";
import axios from 'axios';
import * as Constants from 'utils/Constants';
import HelperFunctions from "utils/HelperFunctions";


export function removePlayWithTouchpointsFromState(payload) {
    return {
        type: MARKETINGPLAYCONFIGURATION.REMOVE_PLAY_WITH_TOUCHPOINTS_FROM_STATE,
        payload
    }
};

export function GetMarketingPlayLookupValues(clientId) {
    return async function (dispatch) {
        try {
            let URL = Constants.MARKETING_PLAY_CONFIGURATION_BASE_URL + 'GetAllMaketingPlayLookups?clientId=' + clientId;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETINGPLAYCONFIGURATION.LOAD_MARKETING_PLAY_LOOKUP,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error);
        }
    };
}

export function GetTouchPointTemplatesByPlayLookupId(playLookupId, clientId) {
    return async function (dispatch) {
        try {
            let URL = Constants.MARKETING_PLAY_CONFIGURATION_BASE_URL + 'GetPlayTouchPointTemplatesByPlayLookupId?clientId=' + clientId + '&playLookupId=' + playLookupId;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETINGPLAYCONFIGURATION.GET_TOUCHPOINTS_TEMPLATE_BY_PLAY_ID,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error);

        }
    };
}

export function SaveMarketingPlayWithTouchpoints(params, clientId) {
    return async function (dispatch) {
        try {
            const response = await axios.post(Constants.MARKETING_PLAY_CONFIGURATION_BASE_URL + 'SaveMarketingPlayWithTouchPoints', {
                marketingPlayViewModel: params.marketingPlayViewModel,
                playTouchPointViewModels: params.playTouchPointViewModels
            }, {
                params: {
                    clientId: clientId
                }
            })
            dispatch({
                type: MARKETINGPLAYCONFIGURATION.SAVE_MARKETING_PLAY_WITH_TOUCHPOINTS,
                payload: response.data
            });

            return HelperFunctions.responseHandlerVNext(response.data);
        } catch (error) {
            console.log("error", error);
        }
    };
}

export function GetAllSchedulesByClientID(clientId) {
    return async function (dispatch) {
        try {
            let URL = Constants.MARKETING_PLAY_CONFIGURATION_BASE_URL + 'GetAllSchedulesByClientID?clientId=' + clientId;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETINGPLAYCONFIGURATION.GET_ALL_SCHEDULES_BY_ClIENTID,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error);
        }
    };
}

export function GetAllPlaysByClientId(clientId) {
    return async function (dispatch) {
        try {
            let URL = Constants.MARKETING_PLAY_CONFIGURATION_BASE_URL + 'GetMarketingPlays?clientId=' + clientId;

            const response = await axios.get(URL);
            const responseData = HelperFunctions.responseHandlerVNext(response.data);
            dispatch({
                type: MARKETINGPLAYCONFIGURATION.GET_ALL_PLAYS_CLIENT_ID,
                payload: responseData
            });
            return responseData;
        } catch (error) {
            console.log("error", error);
        }
    };
}

export function SaveTouchpointScheduleMapping(touchpointId, scheduleId, clientId) {
    return async function (dispatch) {
        try {
            let URL = Constants.MARKETING_PLAY_CONFIGURATION_BASE_URL + 'AddTouchpointScheduleMapping';

            const response = await axios.post(URL, null, {
                params: {
                    clientId: clientId,
                    touchpointId: touchpointId,
                    scheduleId: scheduleId
                }
            });

            dispatch({
                type: MARKETINGPLAYCONFIGURATION.SAVE_TOUCHPOINT_SCHEDULE_MAPPING,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error);
        }
    };
}


export function UpdateTouchpointScheduleMapping(touchpointId, scheduleId, clientId) {
    return async function (dispatch) {
        try {
            let URL = Constants.MARKETING_PLAY_CONFIGURATION_BASE_URL + 'UpdateTouchpointScheduleMapping';

            const response = await axios.patch(URL, null, {
                params: {
                    clientId: clientId,
                    touchpointId: touchpointId,
                    scheduleId: scheduleId
                }
            });

            dispatch({
                type: MARKETINGPLAYCONFIGURATION.UPDATE_TOUCHPOINT_SCHEDULE_MAPPING,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error);
        }
    };
}


export function GetMappedSchedulesByPlayId(playId, clientId) {
    return async function (dispatch) {
        try {
            let URL = Constants.MARKETING_PLAY_CONFIGURATION_BASE_URL + 'GetMappedSchedulesByPlayId?clientId=' + clientId + '&playId=' + playId;

            const response = await axios.get(URL);

            dispatch({
                type: MARKETINGPLAYCONFIGURATION.GET_MAPPED_SCHEDULE_BY_PLAYID,
                payload: HelperFunctions.responseHandlerVNext(response.data)
            });
        } catch (error) {
            console.log("error", error.response);
            console.log(typeof error);
        }
    };
}